import React from 'react';
import useWeek from '../hooks/useWeek';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/es';
import CalendarTitle from './CalendarTitle';
import { Container, Row, Col } from 'reactstrap';
import { CREATE_APPOINTMENT } from '../utils/urls';
moment.locale('es');

const WeekCalendar = (props) => {
  const { week, slots, nextWeek, prevWeek } = useWeek(
    props.start ? moment(props.start, 'DD/MM/YYYY') : moment()
  );

  const get_class = (day, data) => {
    const startTime = data.start;
    const slotTime = `${day} ${startTime}`
    if (moment(slotTime, 'DD/MM/YYYY HH:mm:ss') <= moment()) return 'past';
    else if (!data.available) return 'non-available';
    else return 'available';
  };

  const goToCreate = (day, data) => {
    if (data.available)
      props.history.push(CREATE_APPOINTMENT, {
        slot: { ...data, date: day }
      });
  };

  return (
    <Container>
      <CalendarTitle
        prev={prevWeek}
        title={`${moment(week.start).format('D MMM')} - ${moment(week.end).format('D MMM')}`}
        next={nextWeek}
      />
      <Row>
        <Col xs='12' className='d-flex justify-content-between'>
          <table className='table'>
            <thead>
              <tr className='text-center'>
                <th></th>
                {Object.keys(slots).map(day => (
                  <th key={day}>{moment(day, 'DD/MM/YYYY').format('D MMM')}</th>
                ))}
              </tr>
            </thead>
            {Object.values(slots).length > 0 &&
              <tbody>
                {Object.values(slots)[0].map((slot, i) =>
                  <tr key={`${slot.name}-${i}`}>
                    <td className='times-slots'>
                      {slot.start.slice(0, -3)}
                      <br /> - <br />
                      {slot.end.slice(0, -3)}
                    </td>
                    {Object.values(slots).map((zones, j) => (
                      <td
                        key={`${slot.name}-${i}-${j}`}
                        className={`slot ${get_class(Object.keys(slots)[j], zones[i])}`}
                        onClick={() => goToCreate(Object.keys(slots)[j], zones[i])}
                      />
                    ))}
                  </tr>
                )}
              </tbody>
            }
          </table>
        </Col>
      </Row>
    </Container>
  );
};

export default withRouter(WeekCalendar);